<div class="registrovani-kontakt-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="header-row">
      <div class="header-group">
        <h2 class="page-title">Registrovani Kontakti</h2>
        <p class="page-subtitle">Lista svih registrovanih kontakata</p>
      </div>

      <!-- Refresh Button -->
      <div class="header-group">
        <dx-button text="Osvježi podatke" icon="refresh" type="default" stylingMode="contained" (onClick)="loadData()"
          class="refresh-btn">
        </dx-button>
      </div>
    </div>
  </div>

  <!-- Data Grid Section -->
  <div class="grid-section">
    <dx-data-grid #registrovaniKontaktGrid id="registrovaniKontaktGrid" keyExpr="id" [dataSource]="gridData" [showBorders]="true"
      [allowColumnResizing]="true" [showColumnLines]="true" [showRowLines]="true" [hoverStateEnabled]="true"
      [filterRow]="{ visible: true }" [searchPanel]="{ visible: true }" [paging]="{ pageSize: 50 }" [pager]="{
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      }" [selection]="{ mode: 'single' }" [rowAlternationEnabled]="true">

      <!-- Columns Definition -->
      <dxi-column type="buttons" width="80" caption="Opcije" [visible]="isUserModerator">
        <dxi-button name="delete" icon="trash" hint="Izbriši" [visible]="true" [onClick]="onDeleteClick"></dxi-button>
      </dxi-column>

      <dxi-column dataField="firma.naziv" caption="Firma"></dxi-column>
      <dxi-column dataField="datum" caption="Datum" dataType="date" format="dd.MM.yyyy"></dxi-column>
      <dxi-column dataField="tekst" caption="Tekst"></dxi-column>

      <!-- Master Detail -->
      <dxo-master-detail [enabled]="true" template="detailTemplate">
      </dxo-master-detail>

      <div *dxTemplate="let data of 'detailTemplate'" class="master-detail">
        <div class="detail-section">
          <h4>Detalji kontakta: {{ data.data.firma?.naziv || 'N/A' }}</h4>
          <p><strong>Firma:</strong> {{ data.data.firma?.naziv || 'N/A' }}</p>
          <p><strong>Kontakt osoba:</strong> {{ data.data.firma?.kontakt1 || 'N/A' }}</p>
          <p><strong>Telefon:</strong> {{ data.data.firma?.telefon1 || 'N/A' }}</p>
          <p><strong>Grad:</strong> {{ data.data.firma?.grad1?.grad1 || 'N/A' }}</p>
          <p><strong>Datum kontakta:</strong> {{ data.data.datum | date:'dd.MM.yyyy' }}</p>
          <p><strong>Tekst:</strong> {{ data.data.tekst || 'N/A' }}</p>
        </div>
      </div>
    </dx-data-grid>
  </div>

  <!-- Loading Overlay -->
  <dx-load-panel [position]="loadPanelPosition" [visible]="loading" [showIndicator]="true" [showPane]="true"
    [shading]="true" shadingColor="rgba(0, 0, 0, 0.4)">
  </dx-load-panel>
</div>